import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const pdsinceldConfig: TSPConfig = {
  key: 'pdsinceld',
  name: 'PDS Inc ELD',
  imageName: 'PDSIncELD',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your PDS Inc ELD profile. It should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default pdsinceldConfig;
